import React, { PureComponent, createRef } from 'react';
import { connect } from 'react-redux';
import Button from 'jd-library/Button';
import { bulkUpdateSteps } from './constants/bulkupdateinventory.constants';
import { isValidExcel } from './utils/bulkupdate.utils';
import { showToastMessage } from '../../../actions/toastmessage';
import styles from './Styles/bulk-update-inventory.scss';

class BulkUpdateInitialStep extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExporting: false,
      isUploading: false
    }
    this.inputref = createRef();
    this.handleUpload = this.handleUpload.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  async handleDownload() {
    const { session: { token }, setCurrentStep } = this.props;
    this.setState({ isExporting: true });
    const { default: { get } } = await import('axios');
    const params = {
      action: 'updateHeaderMapping',
      srcType: 'updateInventoryExport',
      token,
      forDc: 1
    }
    const { data } = await get('/marketplace/static/php/web/b2bWebsite.php', { params });
    if (data.isSuccess) {
      setCurrentStep({ step: bulkUpdateSteps.history });
    }
    this.setState({ isExporting: false });
  }

  handleUpload() {
    this.inputref.current?.click();
  }

  handleChange = async (e) => {
    const { session: { token } } = this.props;
    const { target: { files } } = e;
    const { error } = isValidExcel(files[0]);
    if (error) {
      this.props.showToastMessage({
        showToastMessage: true,
        type: 'error',
        message: error,
        duration: 5000,
      })
    } else {
      let params = {
        action: 'updateHeaderMapping',
        srcType: 'updateInventory',
        token,
        forDc:1
      }
      let formData = new FormData();
      formData.append('file', files[0]);
      this.setState({ isUploading: true })
      const { default: { post } } = await import('axios');
      setTimeout(() => {
        post('/marketplace/static/php/web/b2bWebsite.php', formData, { params })
          .then(({ data }) => {
            this.setState({ isUploading: false });
            if (data.isSuccess) {
              this.props.setCurrentStep({ step: bulkUpdateSteps.uploadFile, mongoId: data.mongoId });
            } else if (!data.isSuccess) {
              this.props.showToastMessage({
                showToastMessage: true,
                type: 'error',
                message: data?.msg,
                duration: 5000,
              })
            }
          })
      }, 1200);
    }
  }

  render() {
    const { isExporting, isUploading } = this.state;
    return (
      <div className={styles['bulk-inventory']}>
        <div className={styles['steps-between']}>
          <div className={styles['steps']}>Step 1:</div>
          <div className={styles['step-text']}>Download Your Current Inventory File to Update Existing Information</div>
          <div className={styles['step-lower']}>Download and fill up the required columns in the excel file.</div>
          <Button
            onClick={this.handleDownload}
            variant="primary"
            showLoader={isExporting}
            disabled={isExporting}
            size="sm"
            className={styles['fullwidthbtn']}
          >
            Download Excel File
          </Button>
        </div>
        <hr />
        <div className={styles['steps-between']}>
          <div className={styles['steps']}>Step 2:</div>
          <div className={styles['step-text']}>Upload File to Bulk Update Inventory</div>
          <input
            ref={this.inputref}
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            style={{ display: 'none' }}
            onChange={this.handleChange}
          />
          <Button
            onClick={this.handleUpload}
            variant="primary"
            size="sm"
            className={styles['fullwidthbtn']}
            showLoader={isUploading}
          >
            Upload File
          </Button>
        </div>
      </div>
    )
  }
}

const mapToDispatch = dispatch => ({
  showToastMessage: (props) => dispatch(showToastMessage(props))
})

export default connect(null, mapToDispatch)(BulkUpdateInitialStep);